<template>
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
  >
    <path d="M1.25909 6.60214C1.94254 3.32689 4.79437 1 8.00002 1C11.2057 1 14.0574 3.32688 14.7409 6.60215C14.7974 6.87246 15.0622 7.04587 15.3325 6.98946C15.6029 6.93304 15.7763 6.66817 15.7199 6.39785C14.9425 2.67312 11.6934 0 8.00002 0C4.3066 0 1.05742 2.67311 0.280175 6.39786C0.223767 6.66818 0.397177 6.93305 0.667497 6.98946C0.937817 7.04587 1.20268 6.87246 1.25909 6.60214ZM8 3C6.067 3 4.5 4.567 4.5 6.5C4.5 8.433 6.067 10 8 10C9.933 10 11.5 8.433 11.5 6.5C11.5 4.567 9.933 3 8 3ZM5.5 6.5C5.5 5.11929 6.61929 4 8 4C9.38071 4 10.5 5.11929 10.5 6.5C10.5 7.88071 9.38071 9 8 9C6.61929 9 5.5 7.88071 5.5 6.5Z" />
  </svg>
</template>
